// removed by extract-text-webpack-plugin
module.exports = {"barcode":"_15XJU","barcodeHelperText":"_3RZWG","email":"_3SfZE"};


//////////////////
// WEBPACK FOOTER
// ./app/components/EInvoiceSelector/components/Personal/Personal.scss
// module id = 1509
// module chunks = 1